import { fromJS } from 'immutable';
import {
  SET_PREOPEN_MANAGER_VALIDATED_CLAIMS,
  SET_SEARCH,
} from 'containers/PreOpenManagerValidatedClaims/constants';
import { RESET_STORE } from 'containers/LoginPage/constants';
import { get } from 'lodash';

const initialState: any = fromJS({
  claims: [],
  countClaims: 0,
});

const preOpenManagerValidatedClaimsReducer = (
  state = initialState,
  action: any,
) => {
  switch (action.type) {
    case SET_PREOPEN_MANAGER_VALIDATED_CLAIMS:
      return state
        .set('claims', fromJS(action.response.claims))
        .set('countClaims', fromJS(action.response.total));
    case SET_SEARCH:
      return state
        .set('claims', fromJS(action.data))
        .set('countClaims', fromJS(get(action, 'data', []).length));
    case RESET_STORE:
      return initialState;
    default:
      return state;
  }
};

export default preOpenManagerValidatedClaimsReducer;
